export default function (product) {
  return !product.labels || product.labels.every(label => label !== 'OOS');
}
